export default __webpack_public_path__ + "static/media/Feross Aboukhadijeh.abb7bd00.png";